import { trigger_journey } from './mailchimp-journeys';
import { isValidEmailAddress, getJsonScriptData } from 'utils';


function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return undefined;
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// We show the modal after 10 seconds if modal HTML exists.
// eslint-disable-next-line no-unused-vars
export default () => ({
  open: false,
  error: false,
  success: false,
  sending: false,
  can_save_cookie: false,
  // var debug = '{{DEBUG}}';
  debug: getJsonScriptData('debug'),
  destinationSlug: getJsonScriptData('destination_slug'),

  init() {
    const modalElement = document.getElementById('guide_modal');
    if (!modalElement) {
      return;
    }

    if (getCookie('guide_' + this.destinationSlug)) {
      return;
    }

    this.can_save_cookie = JSON.parse(getCookie('gv_cookie_config') ?? "{}")['acceptPreferences'] ?? false;

    // Show the modal after 10 seconds.
    setTimeout(() => {
      this.open = true;
      this.$nextTick(() => {
        document.getElementById('mautic_email')?.focus();
        this.$dispatch('modal-update', 'open');
      });
    }, 10000);
  },

  close() {
    if (this.can_save_cookie) {
      setCookie('guide_' + this.destinationSlug, 'closed', 0.5);
    }

    // Close the modal
    this.open = false;
    this.success = false;
    this.$dispatch('modal-update', 'close');
  },

  async send() {
    let email = document.getElementById('mautic_email').value;
    if (!email) {
      this.error = "Por favor, escribe tu correo electrónico";
      return;
    }
    if (!isValidEmailAddress(email)) {
      this.error = "Por favor, escribe un correo electrónico válido";
      return;
    }

    this.sending = true;
    const result = await trigger_journey(email, this.destinationSlug);
    this.sending = false;
    if (!result.success) {
      this.error = result.error;
      return;
    }

    if (!this.debug) {
      // eslint-disable-next-line no-undef
      dataLayer.push({ 'event': 'guide' });
    }

    this.open = false;
    this.error = false;
    this.success = true;

    if (this.can_save_cookie) {
      // "Indefinite" in browsers is implemented with a very long-lived cookie.
      setCookie('guide_' + this.destinationSlug, 'sent', 36500);
    }
  }
});